import axios from '../../helpers/axios-setup';

export const getCategories = () => axios.get('/product-model-category-groups/active');
